module.exports = __webpack_public_path__ + "static/banner-9ab4f71d3573f5094c9cc4eb29202e68.jpg";